import { createAction, props } from '@ngrx/store';

import { User } from '@lockton-apps/shared/interfaces';

import { BrokerDetailsActionTypes } from './actions.model';

export const init = createAction(BrokerDetailsActionTypes.BrokerDetailsInit);

export const brokerDeleted = createAction(
  BrokerDetailsActionTypes.BrokerDeleted,
  props<{ user: User }>()
);

export const brokerEnabled = createAction(
  BrokerDetailsActionTypes.BrokerEnabled
);

export const clientsListViewChanged = createAction(
  BrokerDetailsActionTypes.ClientsListViewChanged,
  props<{ viewType: string }>()
);

export const clientsFilterChanged = createAction(
  BrokerDetailsActionTypes.ClientsFilterChanged,
  props<{ filter: Record<string, any> }>()
);

export const viewMoreClients = createAction(
  BrokerDetailsActionTypes.ViewMoreClients
);

export const destroyed = createAction(BrokerDetailsActionTypes.Destroyed);
